import React from "react";
import {Auth0Context} from "@auth0/auth0-react";

export const AppContext = React.createContext(null);

export function AppProvider({ children }) {
    const [orders, setOrders] = React.useState([]);
    const [currentOrder, setCurrentOrderObj] = React.useState({ currentOrder: {_id: 0} });
    const [refreshPending, setRefreshPendingInt] = React.useState(0);
    const [user, setUser] = React.useState(Auth0Context);

    // Override the App's currentUser & logIn properties + include the app-level logout function
    const appContext = React.useMemo(() => {
        const setRefreshPending = () => {
            setRefreshPendingInt((refreshPending + 1) % 100)
        }
        const setCurrentOrder = (obj) => {
            setCurrentOrderObj({currentOrder: obj})
        }
        return { ...currentOrder, setCurrentOrder, refreshPending, setRefreshPending, user, setUser, orders, setOrders };
    }, [currentOrder, refreshPending, user, setUser, orders, setOrders]);
    return (
        <AppContext.Provider value={appContext}>
            {children}
        </AppContext.Provider>
    );
}
